import { html, View } from 'rune-ts';
import { CurationListItem } from '@services/MarppleShop/features/Curation/type';
import klass from './MainPageCurationListView.module.scss';
import { CardCurationView } from '@services/MarppleShop/renderApp/pages/Curation/components/CardCurationView.ts';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';
import { makeEmptyScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { pipe } from '@fxts/core';

type TProps = {
  curations: CurationListItem[];
  is_mobile: boolean;
};

export class MainPageCurationListView extends View {
  protected override template({ curations, is_mobile }: TProps) {
    return html`<div class="${klass.curation}">
      <div class="${klass.section_title}">
        <p class="${classes(klass.section_title_text, font('24_bold', '18_semibold'))}">
          ${ET('curation::main_page_curation_list_view::section_title_text')}
        </p>

        <a
          href="${is_mobile ? `/${ET.lang}/@/curation-feed` : `/${ET.lang}/@/curations`}"
          data-post-message="${pipe(`/${ET.lang}/@/curation-feed`, makeEmptyScreenNavigate, dataStr)}"
          class="${classes(klass.see_more, font('14_medium', '12_medium'))}"
        >
          ${ET('curation::main_page_curation_list_view::see_more')}
        </a>
      </div>

      ${is_mobile
        ? html`<div class="${klass.curation_inner}">
            <div class="${klass.curation_list_wrapper}">
              ${curations.map(
                (curation) =>
                  html`<div class="${klass.card_curation_wrapper}">
                    ${new CardCurationView({ device: 'Mobile', layout: 'Detail', ...curation })}
                  </div>`,
              )}
            </div>
          </div>`
        : html`<div class="${klass.curation_inner}">
            ${curations.map(
              (curation) => new CardCurationView({ device: 'PC', layout: 'Detail', ...curation }),
            )}
          </div>`}
    </div>`;
  }
}
